import { giphyBlack } from '@giphy/colors'
import { CSSProperties, useEffect, useState } from 'react'
import { Gradient } from 'types'
import { brightnessFromColor, gradientToHexColors } from 'utils'

export function useLabelStyle(active: boolean, backgroundColor: string, color: string, gradient?: Gradient) {
    const [value, setValue] = useState<CSSProperties>({})

    useEffect(() => {
        if (!active) {
            const brightness = brightnessFromColor(backgroundColor)

            setValue({
                color: brightness > 0.5 ? giphyBlack : '#fff',
            })
        } else {
            const highlightColor = gradient ? gradientToHexColors(gradient)[0] : color
            const brightness = brightnessFromColor(highlightColor)

            setValue({
                color: brightness > 0.5 ? giphyBlack : '#fff',
            })
        }
    }, [active, backgroundColor, color, gradient])

    return value
}
